import React, { useContext } from "react";
import Style from "./questionItem.module.scss";
import { Icon } from "antd";
import { Multiple } from "./component/multiple";
import { Single } from "./component/single";
import { Tiankong } from "./component/tiankong";
import { Cloze } from "./component/cloze";
import { IQuestion } from "pages/homework";
import { Listening } from "./component/listening";
import { Reading } from "./component/reading";
import { TextEditors } from "./component/editor";
import ExamFileView from "../view";
import { ExamContext } from "../../../Exam/ExamMain/context";
import { isTrue } from "../../../../Utils/filter";

interface IQuestionItemProps {
    item: IQuestion;
    topicType: string;
    trunk: string;
    topicId: number;
    questionIndex?: number;
    homeworkState: number;
    answers: any[];
    contentText?: string | null;
    isRight?: string;
    canPastedText?: boolean;
    onQuestionChange: (
        topicId: number,
        topicType: string,
        answerId: number | number[],
        value?: string,
        userAnswers?: any
    ) => void;
    score?: string;
    topics?: IQuestion[];
    comment?: string | null | undefined;
    onFileDownload?: (fileUrl: string) => void;
}

const QuestionItem = ({
    item,
    trunk,
    topicType,
    questionIndex,
    answers,
    topicId,
    onQuestionChange,
    contentText,
    isRight,
    comment,
    canPastedText = true,
    homeworkState = 1,
    topics = [],
    score,
    onFileDownload
}: IQuestionItemProps) => {
    const handleChange = (
        answerId: number | number[],
        value?: string,
        userAnswers?: any
    ) => {
        onQuestionChange(topicId, topicType, answerId, value, userAnswers);
    };

    const { isExam, examSettings } = useContext(ExamContext);

    //题干
    const trunkFilter = trunk.replace(/<a.*?a>/g, "");
    //描述
    const contentTextFilter = contentText?.replace(/<a.*?a>/g, "");

    return (
        <div className={Style.main}>
            <div className={Style.question}>
                {questionIndex && (
                    <div className={Style.questionIndex}>{questionIndex}、</div>
                )}
                <div
                    className={Style.questionTrunk}
                    dangerouslySetInnerHTML={{ __html: trunkFilter }}
                />

                {/*题干附件预览*/}
                {item?.trunkFileList && item.trunkFileList?.length > 0 && (
                    <div className={Style.fileWrapper}>
                        {item.trunkFileList.map(listItem => (
                            <div key={listItem} className={Style.item}>
                                <ExamFileView
                                    canDownload={
                                        !isExam || // 所有作业允许附件下载
                                        isTrue(examSettings?.allowPaperDownload)
                                    }
                                    officeUrl={
                                        item.officeUrl ||
                                        item.trunkOfficeUrl ||
                                        ""
                                    }
                                    src={listItem}
                                    onDownload={() =>
                                        onFileDownload?.(listItem)
                                    }
                                />
                            </div>
                        ))}
                    </div>
                )}

                {score && <div className={Style.score}> 本小题 {score} 分</div>}
                {isRight === "1" && (
                    <span className={Style.success}>
                        <Icon type="check" />
                        &nbsp;正确
                    </span>
                )}
                {isRight === "0" && (
                    <span className={Style.wrong}>
                        <Icon type="close" />
                        &nbsp;错误
                    </span>
                )}
            </div>
            <div className={Style.list} id={topicId.toString()}>
                {contentText && (
                    <>
                        <div
                            className={Style.questionTrunk}
                            dangerouslySetInnerHTML={{
                                __html: contentTextFilter || ""
                            }}
                        />
                        {/*主观题描述部分的附件预览*/}
                        {item?.fileList && item.fileList?.length > 0 && (
                            <div className={Style.fileWrapper}>
                                {item.fileList.map(listItem => (
                                    <div key={listItem} className={Style.item}>
                                        <ExamFileView
                                            canDownload={
                                                !isExam || // 所有作业允许附件下载
                                                isTrue(
                                                    examSettings?.allowPaperDownload
                                                )
                                            }
                                            officeUrl={
                                                item.officeUrl ||
                                                item.trunkOfficeUrl ||
                                                ""
                                            }
                                            src={listItem}
                                            onDownload={() =>
                                                onFileDownload?.(listItem)
                                            }
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    </>
                )}
                {(parseInt(topicType) === 1 || parseInt(topicType) === 3) && (
                    <Single
                        homeworkState={homeworkState}
                        list={answers}
                        onChange={handleChange}
                    />
                )}
                {parseInt(topicType) === 2 && (
                    <Multiple
                        homeworkState={homeworkState}
                        list={answers}
                        onChange={handleChange}
                    />
                )}
                {parseInt(topicType) === 4 && (
                    <TextEditors
                        canPastedText={canPastedText}
                        homeworkState={homeworkState}
                        list={answers}
                        onChange={handleChange}
                        comment={comment}
                    />
                )}
                {parseInt(topicType) === 5 && (
                    <Tiankong
                        homeworkState={homeworkState}
                        list={answers}
                        onChange={handleChange}
                    />
                )}
                {parseInt(topicType) === 6 && (
                    <Listening
                        homeworkState={homeworkState}
                        topics={topics}
                        onQuestionChange={onQuestionChange}
                    />
                )}
                {parseInt(topicType) === 7 && (
                    <Cloze
                        homeworkState={homeworkState}
                        topics={topics}
                        onQuestionChange={onQuestionChange}
                    />
                )}
                {parseInt(topicType) === 8 && (
                    <Reading
                        homeworkState={homeworkState}
                        topics={topics}
                        onQuestionChange={onQuestionChange}
                    />
                )}
            </div>
        </div>
    );
};

export default QuestionItem;
